import React from "react";
import Helmet from "react-helmet";
import Layout from "../components/layout";
// import Lightbox from 'react-images'

import Gallery from "../components/Gallery";

import full01 from "../assets/images/sportsconnect/ArtemisBlue.jpg";
import full02 from "../assets/images/sportsconnect/DemeterGreen.png";
import full03 from "../assets/images/sportsconnect/Charlotte.png";
import full04 from "../assets/images/sportsconnect/AtlasGold.png";
import full05 from "../assets/images/sportsconnect/Rush.jpg";
import full06 from "../assets/images/sportsconnect/HeliosRed.jpg";

import thumb01 from "../assets/images/thumbs/ArtemisBlue.jpg";
import thumb02 from "../assets/images/thumbs/DemeterGreen.jpg";
import thumb03 from "../assets/images/thumbs/Charlotte.jpg";
import thumb04 from "../assets/images/thumbs/AtlasGold.jpg";
import thumb05 from "../assets/images/thumbs/Rush.jpg";
import thumb06 from "../assets/images/thumbs/HeliosRed.jpg";


const DEFAULT_IMAGES = [
  {
    id: "1",
    source: full01,
    thumbnail: thumb01,
  },
  {
    id: "2",
    source: full02,
    thumbnail: thumb02,
  },
  {
    id: "3",
    source: full03,
    thumbnail: thumb03,
  },
  {
    id: "4",
    source: full04,
    thumbnail: thumb04,
  },
  {
    id: "5",
    source: full05,
    thumbnail: thumb05,
  },
  {
    id: "6",
    source: full06,
    thumbnail: thumb06,
  },
];

const SportsConnect = () => (
  <Layout>
           <Helmet>
          <title>Andy Miller - Sports Connect Themes</title>
        </Helmet>
        <div id="main">
    <h1>Sports Connect Themes</h1>
    <p>I designed website themes and custom website solutions for customers on the Sports Connect platform. The main challenge in these themes was the need to accommodate all of our content modules offered while still creating a coherent sports-centric design. Each theme needed to cover three different versions; Dark, Light, and Color, and also included 16 different color variations. This meant there were 48 designs for a single finished theme. Custom websites were also offered to customers for a price, these allowed me to form designer-client relationships with large sized organizations around the United States. Sports Connect custom websites challenged me to create the customer's vision of their site within our theme-based, modular content management system.</p>
    <Gallery
              images={DEFAULT_IMAGES.map(
                ({ id, source, thumbnail, caption, description }) => ({
                  source,
                  thumbnail,
                })
              )}
            />
    </div>
  </Layout>
);

export default SportsConnect;
